function accountDatepicker() {
  $('.field.date').datepicker();
}

export default accountDatepicker();



// WEBPACK FOOTER //
// ../markup/assets/js/account-datepicker.js